module.exports = __webpack_public_path__ + "static/39-937f41a1e6a9215fcb1ccf10f180a4bc.jpg";